export enum PresenceType {
  Normal = 'Normal',
  Exam = 'Exam',
  ExamRetake = 'ExamRetake',
  Remediation = 'Remediation',
  ModuleRetake = 'ModuleRetake',
  SchoolWork = 'SchoolWork',
  /** No course at that period: the cell is suspended (see PresenceTypeDefinition.expectsPresence). */
  Suspended = 'Suspended',
  /**
   * « Avec un spécialiste » (#1226): the student spends the period with a specialist, on the same
   * competency. Written by the booking routes only, credited to the specialist who takes the
   * attendance — never offered in the activity pickers.
   */
  SpecialistSupport = 'SpecialistSupport'
}
